import { PlusIcon } from '@heroicons/react/outline';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../components/buttons';

interface IAddAudienceButtonProps {
  onClick?: () => void;
}

const AddAudienceButton: FunctionComponent<IAddAudienceButtonProps> = ({ onClick }) => {
  const { t } = useTranslation('audiences');

  return (
    <Button variant='confirm' icon={PlusIcon} className='h-9 mr-6' onClick={onClick}>
      {t('buttons.add_audience')}
    </Button>
  );
};

export default AddAudienceButton;
